var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery, } from 'react-query';
import { useNamespace, useOkapiKy, } from '@folio/stripes/core';
import { ALL_RECORDS_CQL, LIMIT_MAX, } from '@folio/stripes-acq-components';
import { fetchClaims } from '../../utils';
var DEFAULT_DATA = [];
export var useClaims = function (params, options) {
    if (params === void 0) { params = {}; }
    if (options === void 0) { options = {}; }
    var _a = params.query, query = _a === void 0 ? ALL_RECORDS_CQL : _a, _b = params.offset, offset = _b === void 0 ? 0 : _b, _c = params.limit, limit = _c === void 0 ? LIMIT_MAX : _c;
    var _d = options.breakWithDefaults, breakWithDefaults = _d === void 0 ? false : _d, _e = options.enabled, enabled = _e === void 0 ? true : _e, keepPreviousData = options.keepPreviousData, queryKey = options.queryKey, tenantId = options.tenantId;
    var searchParams = {
        query: query,
        offset: offset,
        limit: limit,
    };
    var ky = useOkapiKy({ tenant: tenantId });
    var namespace = useNamespace({ key: 'claims' })[0];
    var _f = useQuery({
        queryKey: [namespace, queryKey, query, offset, limit, tenantId, breakWithDefaults],
        queryFn: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var signal = _b.signal;
            return __generator(this, function (_c) {
                if (breakWithDefaults) {
                    return [2 /*return*/, {
                            claims: DEFAULT_DATA,
                            totalRecords: 0,
                        }];
                }
                return [2 /*return*/, fetchClaims(ky)({ searchParams: searchParams, signal: signal })];
            });
        }); },
        enabled: enabled,
        keepPreviousData: keepPreviousData,
    }), data = _f.data, isFetching = _f.isFetching, isLoading = _f.isLoading, refetch = _f.refetch;
    return {
        claims: (data === null || data === void 0 ? void 0 : data.claims) || DEFAULT_DATA,
        totalRecords: (data === null || data === void 0 ? void 0 : data.totalRecords) || 0,
        isFetching: isFetching,
        isLoading: isLoading,
        refetch: refetch,
    };
};
